import React, { useContext, useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import DelTableRowModal from "../../../modals/delTableRowModal";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../context/AppContext";

const ConfedentialityTable = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isdelModalOpen, setIsdelModalOpen] = useState(null);
  const [cases, setCases] = useState([]);
  const { allCases } = useContext(AppContext);

  const onDelClick = (caseId) => {
    setIsdelModalOpen(caseId);
  };

  const handleDetailsClick = (confeItem) => {
    
    console.log("Confedential Item:", confeItem);
    navigate("/confedentiality-and-security/details",
    {
      state: { confeItem }
    }
    );
  };
  const columns = [
    {
      title: t("dashboard.confedentialitySecurity.documentName"),
      dataIndex: "documentName",
      key: "documentName",
      render: (text) => (
        <p className="text-darkGrey small font-poppins">{text}</p>
      ),
    },
    {
      title: t("dashboard.confedentialitySecurity.taskAssignments"),
      dataIndex: "taskAssignment",
      key: "taskAssignment",
      render: (task) => (
        <p className="text-darkGrey small font-poppins">{task}</p>
      ),
    },
    {
      title: t("dashboard.confedentialitySecurity.uploadDate"),
      dataIndex: "uploadDate",
      key: "uploadDate",
      render: (date) => (
        <p className="text-darkGrey small font-poppins">{date}</p>
      ),
    },
    {
      title: t("dashboard.confedentialitySecurity.incidentID"),
      dataIndex: "incidentID",
      key: "incidentID",
      render: (incidentID) => (
        <p className="text-darkGrey small font-poppins">C{incidentID}</p>
      ),
    },
    {
      title: t("dashboard.confedentialitySecurity.actions"),
      key: "actions",
      render: (_, record) => (
        <div className="flex gap-[18px]">
          <p
            className="text-secondary cursor-pointer flex justify-center items-center small font-poppins w-[83px] h-[34px] bg-[#D3EFF4] rounded-[47px]"
            onClick={() => handleDetailsClick(record)}
            // onClick={() => {
            //   navigate("/confedentiality-and-security/details");
            // }}
          >
            {t("dashboard.confedentialitySecurity.details")}
          </p>
          <img
            src="../../assets/icons/del.png"
            alt=""
            className="cursor-pointer"
            onClick={() => {
              onDelClick(record._id);
            }}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    const resultedData = allCases.data?.map((item, index) => {
      return {
        key: index + 1,
        documentName: item.document_name || "N/A",
        taskAssignment: item.task_assignments || "N/A",
        uploadDate: item.upload_date.split("T")[0] || "N/A",
        incidentID: item.caseId || "N/A",
        _id: item._id,
      };
    });

    console.log(allCases.data);
    setCases(resultedData);
  }, [allCases]);

  return (
    <>
      {" "}
      <Table
        columns={columns}
        dataSource={cases}
        pagination={{
          position: ["bottomCenter"],
          pageSize: 6,
          itemRender: (current, type, originalElement) => {
            if (type === "prev") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-left-bold" color="#143A62" />
                </div>
              );
            }
            if (type === "next") {
              return (
                <div className="bg-[#DADDE1] w-[36px] h-[36px] rounded-[9px] flex items-center justify-center">
                  <Icon icon="ep:arrow-right-bold" color="#143A62" />
                </div>
              );
            }
            return originalElement;
          },
          showSizeChanger: false,
          className: "custom-pagination",
        }}
        className="w-full"
        scroll={{ x: "1000px" }}
      />
      <DelTableRowModal
        isdelModalOpen={isdelModalOpen}
        setIsdelModalOpen={setIsdelModalOpen}
      />
    </>
  );
};

export default ConfedentialityTable;
